import { render, staticRenderFns } from "./VipTask.vue?vue&type=template&id=3678c434&scoped=true&"
import script from "./VipTask.vue?vue&type=script&lang=js&"
export * from "./VipTask.vue?vue&type=script&lang=js&"
import style0 from "./VipTask.vue?vue&type=style&index=0&id=3678c434&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678c434",
  null
  
)

export default component.exports